<template>
  <span>
    <template v-if="isForbidden()">
      <span v-if="message">{{ message }}</span>
      <a-alert
        message="Forbidden"
        type="error"
        v-if="!skipAlert" />
    </template>
    <template v-else>
      <slot />
    </template>
  </span>
</template>

<script>
import PermissionService from '@/js/permissions'
import AAlert from 'ant-design-vue/lib/alert'

export default {
  name: 'permission-wrapper',
  components: {
    AAlert,
  },
  props: {
    message: {
      type: String,
      default: () => '',
    },
    pageName: {
      type: String,
      required: true,
      default: () => '',
    },
    resourceName: {
      type: String,
      required: true,
      default: () => '',
    },
    actionName: {
      type: String,
      required: true,
      default: () => '',
    },
    skipAlert: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
      permissionService: new PermissionService(),
    }
  },
  methods: {
    isForbidden () {
      const result = this.permissionService.isChildrenForbidden(
        this.pageName,
        this.resourceName,
        this.actionName,
        this.$store.getters.myRoleInfo.permissions,
      )
      return result
    },
  },
}
</script>

<style scoped lang="scss" >
  @import '~ant-design-vue/lib/alert/style/index.css';
</style>
